import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Banner from "components/organisms/Banner";
import { Wave } from "components/organisms/Wave";
import BusinessGuides from "components/templates/offshore/guide-and-tool/components-tool/BusinessGuides";
import ToolTabList from "components/templates/offshore/guide-and-tool/components-tool/ToolTabList";

import ServiceCategory from "./components-tool/ServiceCategory";

const GuideAndTool = ({ dataJson }) => {
  return (
    <div className="relative ">
      <Banner
        minHeightBanner="banner-min-h-569"
        breadcrumbs={dataJson?.breadcrumbs}
        title={dataJson?.title}
        titleProps={{
          className: "banner-default-title mb-4 lg:mb-10",
          textColor: "banner-title-default-color",
        }}
        description={dataJson?.description}
        descriptionProps={{
          className: "text-center lg:text-left lg:pr-20",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={dataJson?.banner_image}
            className="h-full w-full"
            wrapper={{
              className: "bbc-banner-image-country pb-10 lg:pb-0",
            }}
            width={dataJson?.banner_image_width || 516}
            height={dataJson?.banner_image_height || 420}
            alt="banner-img"
          />
        }
        bgColor="bg-bbc-gradient-8"
      ></Banner>
      <section id="section-business-guide" className="mt-10 lg:mt-20">
        <BusinessGuides
          title="Business guides"
          description={dataJson?.businessDescription}
          dataList={dataJson?.dataBusinessGuides}
          wrapperStyles="lg:col-12"
          contentStyles="lg:col-4"
        />
      </section>
      <Wave
        background="lg:bg-[#EFF6FF]"
        srcTop="/assets/images/wave/top_bg-wave.png"
        imgWidthTop={1920}
        imgHeightTop={125}
        srcBottom="/assets/images/wave/bottom-wave.png"
        imgWidthBottom={1920}
        imgHeightBottom={140}
        style={{ top: "40%" }}
        heightBottom=" h-4/5 "
        sectionTop={
          <div className="container relative z-10 text-center">
            <Title
              text={dataJson.dataToolAndResources?.title}
              className="title-h2 mb-2 text-bbc-30px text-bbc-brand-700 lg:mb-10"
            />
            <p className="mb-8 lg:mb-10">
              {dataJson.dataToolAndResources?.description}
            </p>
            <div className="row justify-center">
              <div className="col-12 px-0 lg:col-10">
                <div className="h-full">
                  <Img
                    wrapper={{
                      className:
                        "w-full h-auto flex justify-center lg:justify-start items-center bottom-0 top-20 pb-10",
                    }}
                    className="w-full"
                    alt="resources-img"
                    {...dataJson.dataToolAndResources?.image}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        sectionBottom={
          <ToolTabList dataList={dataJson.dataToolAndResources?.data} />
        }
      />
      <section id="section-service-category">
        <ServiceCategory
          title="We have more for you to try below"
          description="Recommended Reading"
          dataList={dataJson.services}
        />
      </section>
    </div>
  );
};

export default GuideAndTool;
